import { apiGetPendingContracts } from "services/ContractService";
import resolveContractCompanyScope from "utils/resolveContractCompanyScope";

const dedupeByVersionId = (items) => {
  const seen = new Set();

  return items.filter((item) => {
    const id = item?.contractversionid;
    if (!id || seen.has(id)) {
      return false;
    }
    seen.add(id);
    return true;
  });
};

/** Mol-e pending önce, whitelabel domain pending sonra. */
const fetchDomainPendingContracts = async () => {
  const { moleCompanyId, supplementalCompanyId } =
    await resolveContractCompanyScope();

  const ordered = [];

  if (moleCompanyId) {
    const response = await apiGetPendingContracts({ companyid: moleCompanyId });
    ordered.push(
      ...(response?.data?.data ?? []).map((item) => ({
        ...item,
        isSupplemental: false,
      })),
    );
  }

  if (supplementalCompanyId) {
    const response = await apiGetPendingContracts({
      companyid: supplementalCompanyId,
    });
    ordered.push(
      ...(response?.data?.data ?? []).map((item) => ({
        ...item,
        isSupplemental: true,
      })),
    );
  }

  return dedupeByVersionId(ordered);
};

export default fetchDomainPendingContracts;
